import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const AchievementList = Loadable(
  lazy(() => import("features/achievement/components/List"))
);
const AchievementPage = Loadable(
  lazy(() => import("features/achievement/components/Page"))
);

const routes = {
  path: "achievements",
  children: [
    { path: "", element: <AchievementList /> },
    { path: "add", element: <AchievementPage /> },
    { path: "edit/:achievementID?", element: <AchievementPage /> },
  ],
};

export default routes;
